import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { AggregatorAccount, CarRental, VehicleCategory } from '~/shared/api'
import { AsyncAutocompleteInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type AdditionalInformationProps = {
  showSkeleton?: boolean
  disabled?: boolean
}

export function AdditionalInformation({
  showSkeleton,
  disabled,
}: AdditionalInformationProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('additional information')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.aggregator account'
            name='aggregatorAccountOption'
            placeholder='form.select aggregator account'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            fetchOptions={AggregatorAccount.fetchOptions}
          />
        </Grid>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.lessor'
            name='carRentalId'
            placeholder='form.select lessor'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            fetchOptions={CarRental.fetchOptions}
          />
        </Grid>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.vehicle category'
            name='vehicleCategoryId'
            placeholder='form.select vehicle category'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            fetchOptions={VehicleCategory.fetchOptions}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.callsign'
            name='callsign'
            placeholder='form.callsign'
            skeletonShow={showSkeleton}
            readOnly
          />
        </Grid>
      </Grid>
    </Container>
  )
}
